import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router';
import { usePaged, useApiQuery, useApiMutation } from '@kts/client';
import { api } from './api';

export { useCan, useAuth, errorMessage } from '@kts/client';

/** Sahifalangan ro'yxat (shu ilovaning API klienti bilan). */
export function useList<T>(path: string, params: Record<string, unknown>, opts?: { enabled?: boolean; refetchInterval?: number }) {
  return usePaged<T>(api, path, params, opts);
}

export function useGet<T>(path: string | null, params?: Record<string, unknown>, opts?: { enabled?: boolean; refetchInterval?: number; staleTime?: number }) {
  return useApiQuery<T>(api, path, params, opts);
}

export { useApiMutation as useMutate };

/** Qiymatni kechiktirish (qidiruv maydoni). */
export function useDebounced<T>(value: T, ms = 300): T {
  const [v, setV] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setV(value), ms);
    return () => clearTimeout(t);
  }, [value, ms]);
  return v;
}

/**
 * Ro'yxat holati URL da (`?page=2&q=...&status=new`) — sahifa yangilansa yoki havola
 * ulashilsa ham filtrlar saqlanadi.
 */
export function useListState<F extends Record<string, string | undefined>>(defaults: F & { sort?: string }) {
  const [sp, setSp] = useSearchParams();
  const page = Number(sp.get('page') ?? 1) || 1;
  const pageSize = Number(sp.get('pageSize') ?? 25) || 25;
  const q = sp.get('q') ?? '';
  const sort = sp.get('sort') ?? defaults.sort;
  const filters = Object.fromEntries(Object.keys(defaults).map((k) => [k, sp.get(k) ?? defaults[k]])) as F;

  const set = (patch: Record<string, string | number | undefined | null>, resetPage = true) => {
    const next = new URLSearchParams(sp);
    for (const [k, v] of Object.entries(patch)) {
      if (v === undefined || v === null || v === '') next.delete(k);
      else next.set(k, String(v));
    }
    if (resetPage && !('page' in patch)) next.delete('page');
    setSp(next, { replace: true });
  };

  return {
    page,
    pageSize,
    q,
    sort,
    filters,
    setPage: (p: number) => set({ page: p }, false),
    setPageSize: (s: number) => set({ pageSize: s }),
    setQ: (v: string) => set({ q: v }),
    setSort: (s: string | undefined) => set({ sort: s }, false),
    setFilter: (k: keyof F & string, v: string | undefined) => set({ [k]: v }),
    params: { page, pageSize, q: q || undefined, sort, ...filters },
  };
}

export { api };
